import 'whatwg-fetch'; // fetch polyfill

import {
	setAlert, setAlertNextPage,setError
} from 'helpers/alertHelpers';
import {
	postCheckout, setBodyBusy
} from 'helpers/paymentHelpers';
import {
	filter, includes, isEmpty,map
} from 'lodash';
import React, { useEffect } from 'react';

const Submit = (props) => {
	useEffect(() => {
		setBodyBusy(props.bodyBusy);
	},
	[props.bodyBusy]);

	async function submit(props) {
		const {
			setBodyBusy, openCrossSell, setRXCrossSell, setConsultationID, setABTestValue, isPaymentCadence,
		} = props;
		setBodyBusy(true);
		// only log amplitude events when there are products being purchased.
		if (!isEmpty(props.cart?.products)) {
			const num_of_ar_items = filter(props.cart.products,
				(product) => product.autorefill?.selected)?.length || 0;
			const total_cart_items = Object.keys(props.cart.products)?.length || 0;
			const cart_items = filter(props.product_options,
				(product) => props.cart.products[product.id]);
			const ar_order_details = num_of_ar_items / total_cart_items <= 0 ? 'NOAR_Order' : num_of_ar_items / total_cart_items < 1 ? 'AR_and_NOAR_Order' : 'AR_Only_order';
			const num_of_non_ar_items = total_cart_items - num_of_ar_items;
			const num_of_items_removed = props.product_options?.length - total_cart_items;
			const num_of_topicals = filter(cart_items,
				(product) => product.medication_type === 'topical')?.length || 0;
			const num_of_otcs = filter(cart_items,
				(product) => product.otc_id)?.length || 0;
			const num_of_orals = total_cart_items - num_of_topicals - num_of_otcs;
			const out_of_cart_items = filter(props.product_options,
				(product) => !props.cart.products[product.id]);
			const num_of_removed_topicals = filter(out_of_cart_items,
				(product) => product.medication_type === 'topical')?.length || 0;
			const num_of_removed_otcs = filter(out_of_cart_items,
				(product) => product.otc_id)?.length || 0;
			const num_of_removed_orals = out_of_cart_items.length - num_of_removed_topicals - num_of_removed_otcs;

			logAmplitudeEvent('Checkout_response',
				{
					checkout_page_order_details: ar_order_details,
					checkout_page_AR_quantity: num_of_non_ar_items,
					checkout_page_nonAR_quantity: num_of_ar_items,
					checkout_page_removed_quantity: num_of_items_removed,
					'checkout_purchased_item_type.Topical': num_of_topicals > 0 ? true : false,
					'checkout_purchased_item_type.Oral': num_of_orals > 0 ? true : false,
					'checkout_purchased_item_type.OTC': num_of_otcs > 0 ? true : false,
					'checkout_removed_item_type.Topical': num_of_removed_topicals > 0 ? true : false,
					'checkout_removed_item_type.Oral': num_of_removed_orals > 0 ? true : false,
					'checkout_removed_item_type.OTC': num_of_removed_otcs > 0 ? true : false,
				});

		}


		logAmplitudeEvent('submit_page',
			{ submit_page_actions: 'submit_payment_button' })


		// let postCheckout determine the payment method based on the default payment type
		const res = await postCheckout(props);
		if (res.success) {
			setAlertNextPage('success',
				res.successMessage);
			const {
				response, nextStep,
			} = res;
			if (response.cross_sell) {
				setBodyBusy(false);
				openCrossSell(nextStep,
					response.cross_sell);
			} else if (response.rx_credit_cross_sell && response.consultation_id) {
				setBodyBusy(false);
				setRXCrossSell(true);
				setConsultationID(response.rx_credit_cross_sell.consultation_id);
				setABTestValue(response.rx_credit_cross_sell.rx_credit_cross_sell);
				// #TODO setStepNext(nextStep) and change to use state rather than window variable
				window.Yoderm.data.stepNext = nextStep;
			} else {
				window.location = nextStep;
			}
		} else {
			// display new error banner located in www/js/react/apps/progressBar/src/App.js
			if (props.isFollowupv2) {
				setError('error',
					res.errorMessage)
			}
			else{
				setAlert('error',
					res.errorMessage);
			}
			setBodyBusy(false);
		}
	}

	return (
		<button
			onClick={() => {
				typeof props.onClick == 'function' && props.onClick();
				return submit(props);
			}}
			disabled={props.disabled || props.bodyBusy}
			type="submit"
		>
			{props.prePurchase === 'true' ? 'Confirm Order' : `${props.buttonText}`}
		</button>
	);
};

Submit.defaultProps = {
	buttonText: 'Submit payment',
};
export default Submit;
